module.exports = __webpack_public_path__ + "img/logo-adveroo-blue.5309f0ed.svg";